import React from 'react'
import { FlowCardProps } from './types'
import styles from './FlowCard.module.scss'

export const StyledFlowCard: React.FC<FlowCardProps> = (props) => {
  return (
    <div
    className={
      `
      flex bg-member-gray-0 border-1 border-member-gray-40 rounded-M py-M pr-M pl-S items-center gap-XL
      tablet:py-XL tablet:pr-XL tablet:pl-M tablet:gap-XL
      desktop:py-XL desktop:px-L desktop:gap-M desktop:flex-col
      ${styles.flowCardContainer}
      ${props.className ?? ''}
      `
    }
    >
      <div
        className={
          `
            gap-S
            tablet:gap-M
            ${styles.heading}
          `
          }
      >
        <img
          className={
          `
            items-center
            ${styles.stepNumber}
          `
          }
          src={props.image}
          alt={props.alt}/>
        <div
          className={
            `
            flex text-S text-member-gray-100 font-bold items-center
            desktop:justify-center desktop:text-M
            ${styles.stepHeader}
            `
          }
          >
          {props.headerText}
        </div>
      </div>
        <p
          className={
            `
            text-XS text-member-gray-80
            ${styles.stepText}
            `
          }
          style={{textAlign: 'start'}}
        >
          {props.text}
        </p>
    </div>
  );
};
